import React from 'react';

import { ListItem, ListItemText, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme)=>({
    Text : {
        fontFamily: 'Inter',
        fontStyle: 'normal',
        fontWeight: '500',
        fontSize: '16px',
        lineHeight: '24px',
        letterSpacing: '-0.011em',
        backgroundColor : 'black',
        color: '#e5e7eb',

    }
}));

export default function DownloadListItem({file}){

    const classes = useStyles();

    return(
        <ListItem button>
            <ListItemText classes={{ primary : classes.Text }} primary={ file.length > 10 ? file.slice(0,10) + '...' + file.slice(file.length - 4,) : file } />
        </ListItem>
    )

}